import React from 'react'
import {graphql, useStaticQuery} from "gatsby";
import {BlogPostsQuery} from "../../gql/types";
import {Box} from "@chakra-ui/react";
import PostPreviewFlat from "./PostPreviewFlat";
import PostPreview from "./PostPreview";
import {calcReadingTime} from "../../utils/calcReadingTime";

export interface PreviewListProps {
  displayFlat?: boolean;
}

const PreviewList: React.FC<PreviewListProps> = ({displayFlat}) => {
  const data = useStaticQuery<BlogPostsQuery>(graphql`
      query blogPosts {
          allMdx(sort: {order: DESC, fields: frontmatter___date}) {
              edges {
                  node {
                      slug
                      body
                      frontmatter {
                          title
                          author
                          date(formatString: "MMMM DD, YYYY")
                          intro
                          subtitle
                          tags
                      }
                  }
              }
          }
      }
  `);

  return (
    <Box px={64} display={displayFlat ? 'block' : 'flex'}>
      {data.allMdx.edges.map((edge, i) => {
        if (!edge.node.frontmatter) {
          return null;
        }

        const {title, subtitle, date, intro, author, tags} = edge.node.frontmatter;

        const readingTime = calcReadingTime(edge.node.body)

        if (displayFlat) {
          return <PostPreviewFlat key={i} link={edge.node.slug ?? '/'} date={date} readingTime={readingTime}
                                  subtitle={subtitle}
                                  title={title} />
        } else {
          return <PostPreview key={i} link={edge.node.slug ?? '/'} author={author} date={date} readingTime={readingTime}
                              title={title} intro={intro} heading={subtitle} tags={tags?.split(',') ?? []}/>
        }
      })}
    </Box>
  )
}

export default PreviewList
